export default __webpack_public_path__ + "static/media/CAFEBook.fdc0f7c6aa3062b4b6309e2e7eec5cc3.webp";